export default __webpack_public_path__ + "static/media/flag-nigeria.710e75b6.png";